(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-calculator"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', (event) => {
    const form = document.querySelector('.spring-calculator form');

    form.querySelectorAll('select,input[type="number"]').forEach(item => {
      item.addEventListener('change', springCalculator)
    })

    form.querySelectorAll('input[type="number"]').forEach(item => {
      item.addEventListener('keyup', springCalculator)
    })
  })

  function springCalculator(event) {
    const form = event.target.closest('form');
	const springRates = form.parentElement.querySelector('.spring-rates');
	const singlePivotRate = form['single-pivot-rate'];
	const vppPivotRate = form['vpp-rate'];

    const weigth = parseFloat(form['weight'].value);
    const weigthUnit = form['weight_unit'].value;
    const shockStroke = parseFloat(form['shock_stroke'].value);
    const shockStrokeUnit = form['shock_stroke_unit'].value;
    const wheelTravel = parseFloat(form['wheel_travel'].value);
    const wheelTravelUnit = form['wheel_travel_unit'].value;
    const sagSetting = parseFloat(form['sag_setting'].value);

    if (isNaN(weigth) || isNaN(shockStroke) || isNaN(wheelTravel) || isNaN(sagSetting)) {
	  singlePivotRate.value = '';
	  vppPivotRate.value = '';
      return;
    }

    const normalizedWeigth = springConvertUnit(weigth, weigthUnit);
    const normalizedShockStroke = springConvertUnit(shockStroke, shockStrokeUnit);
    const normalizedWheelTravel = springConvertUnit(wheelTravel, wheelTravelUnit);

    const springRate = calculateSpringRate(
      normalizedWeigth,
      sagSetting,
      normalizedShockStroke,
      normalizedWheelTravel
    );

    const vppSpringRate = calculateSpringRate(
      normalizedWeigth,
      sagSetting,
      normalizedShockStroke,
      normalizedWheelTravel,
      "vpp"
    );

    singlePivotRate.value = springRate;
    vppPivotRate.value = vppSpringRate;
  }

  function calculateSpringRate(weigth, sag, shockStroke, wheelTravel, type) {
    return Math.round(
      ((weigth * springGenerateSagFactor(sag, type)) / shockStroke) *
      (wheelTravel / shockStroke)
    );
  }

  const LB_IN_KG = 2.2;
  const MM_IN_INCH = 25.4;
  function springConvertUnit(value, unit) {
    if (unit === "lb") {
      return value / LB_IN_KG;
    }

    if (unit === "mm") {
      return value / MM_IN_INCH;
    }

    return value;
  }

  const RSF_FACTOR = 4.5;
  const VPP_RSF_FACTOR = 4.9;
  function springGenerateSagFactor(sag, type) {
    const normalizedSag = sag * 0.06;
    const factor = type === "vpp" ? VPP_RSF_FACTOR : RSF_FACTOR;

    return factor + normalizedSag;
  }

  


  } catch(e) { console.error(e); }
})();
})();
